import { Card, Typography } from "antd";
import { FrownOutlined } from "@ant-design/icons";
import { red } from "@ant-design/colors";
import { LinkButton } from "../../components/LinkButton";

export const NotFound = () => {
  return (
    <div className="flex items-center justify-center h-screen">
      <Card className="p-8 rounded-2xl shadow-lg text-center">
        <div className="flex flex-col items-center">
          <FrownOutlined
            style={{ color: red.primary }}
            className="text-4xl mb-1 animate-pulse"
          />
          <Typography.Title className="mb-2" level={2}>
            404 Not Found
          </Typography.Title>
          <Typography.Text className="mb-4">
            The page you are looking for does not exist.
          </Typography.Text>
          <LinkButton to="/" type="primary">
            Go Home
          </LinkButton>
        </div>
      </Card>
    </div>
  );
};

export default NotFound;
